import { useContext, useState } from "react";
import { useWeb3React } from "@web3-react/core";
import {
  Flex,
  IconButton,
  Button,
  Box,
  Spinner,
  Icon,
  Center,
} from "@chakra-ui/react";
import { AiOutlineMore } from "react-icons/ai";
import { FiMenu } from "react-icons/fi";

// Types
import { MobileProps } from "./Sidebar.types";

// Components
import WalletInfo from "components/WalletInfo";

// Contexts
import { StakeContext } from "providers/StakeProvider";

// Components
import Logo from "components/Logo";
import NetworkToggler from "./NetworkToggler";
import SubHeader from "./SubHeader";

// Constants
import { STADER_URL } from "constants/constants";

const MobileNav = ({ onOpen, extraItems, ...rest }: MobileProps) => {
  const { active } = useWeb3React();
  const [isSubMenuVisible, setIsSubMenuVisible] = useState(false);
  const { balLoading: loading, openWalletModal } = useContext(StakeContext);

  return (
    <Flex
      ml={{ base: 0, xl: 60 }}
      px={{ base: 4, xl: 4 }}
      height="20"
      alignItems="center"
      borderBottomWidth="1px"
      justifyContent={{ base: "space-between", xl: "flex-end" }}
      border="none"
      {...rest}
    >
      <Center>
        <IconButton
          display={{ base: "flex", xl: "none" }}
          onClick={onOpen}
          aria-label="open menu"
          h={{ base: "36px", lg: "52px" }}
          w={{ base: "36px", lg: "52px" }}
          bg="brand.backgroundLight"
          icon={<FiMenu />}
          _active={{
            bg: "brand.primary",
            color: "brand.textLight",
          }}
        />
        <Box display={{ base: "inherit", xl: "none" }} height="2rem" ml="1rem">
          <a href={STADER_URL}>
            <Icon as={Logo} />
          </a>
        </Box>
      </Center>
      <Flex alignItems="center">
        <NetworkToggler />
        <Box ml="1rem">
          {active ? (
            <WalletInfo />
          ) : (
            <Button
              bg="brand.primary"
              color="brand.textLight"
              h={{ base: "36px", md: "52px" }}
              fontSize={{ base: "14px", md: "1rem" }}
              onClick={() => openWalletModal("Top Right")}
              disabled={loading}
            >
              {loading ? (
                <Spinner size="md" color="brand.textLight" />
              ) : (
                "Connect Wallet"
              )}
            </Button>
          )}
        </Box>
        <IconButton
          display={{ base: "inline-flex", xl: "none" }}
          alignItems="center"
          icon={
            <AiOutlineMore height="24px" width="24px" color="brand.textColor" />
          }
          onClick={() => setIsSubMenuVisible(true)}
          variant="outline"
          aria-label="change theme"
          fontSize="20px"
          bg="brand.backgroundLight"
          h={{ base: "36px", md: "52px" }}
          w={{ base: "36px", md: "52px" }}
          ml="0.5rem"
          border="none"
          borderRadius="8px"
          outline="none"
          _focus={{
            border: "none",
            outline: "none",
          }}
          _hover={{
            bg: "brand.primary",
            color: "brand.textLight",
          }}
        />

        <SubHeader
          headerOptions={extraItems}
          shouldDisplayMenu={isSubMenuVisible}
          onChangeDisplayMenu={(isVisible: boolean) =>
            setIsSubMenuVisible(isVisible)
          }
        />
      </Flex>
    </Flex>
  );
};

export default MobileNav;
